export default __webpack_public_path__ + "static/media/sales-info.831b61ba.png";